const Section = {
  Settings: 'Settings',
  Results: 'Results',
};

export default Section;
